import React from "react";
import "./index.css";
import "semantic-ui-css/semantic.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import { store, StoreContext } from "./stores/store";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import OasisPublicPage from "./Components/PublicSite/oasisPublicPage";
import { ToastContainer } from "react-toastify";
import i18next from "i18next";
import common_ru from "./translations/ru/common.json";
import common_uz from "./translations/uz/common.json";
import common_en from "./translations/en/common.json";
import common_kh from "./translations/kh/common.json";
import common_vn from "./translations/vn/common.json";
import common_id from "./translations/id/common.json";
import { I18nextProvider } from "react-i18next";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
export const history = createBrowserHistory();

const config: Configuration = {
  auth: {
    clientId: "d3df106d-b0da-4981-a1a8-2672c8b1b26b",
  },
  cache: {
    cacheLocation: "localStorage",
  },
};
const publicClientApplication = new PublicClientApplication(config);

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en", // language to use
  resources: {
    en: { common: common_en },
    uz: { common: common_uz },
    ru: { common: common_ru },
    kh: { common: common_kh },
    vn: { common: common_vn },
    id: { common: common_id },
  },
});

root.render(
  <>
    <ToastContainer position="bottom-right" hideProgressBar />
    <StoreContext.Provider value={store}>
      <MsalProvider instance={publicClientApplication}>
        <I18nextProvider i18n={i18next}>
          <Router history={history}>
            <UnauthenticatedTemplate>
              <OasisPublicPage />
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
              <OasisPublicPage />
            </AuthenticatedTemplate>
          </Router>
        </I18nextProvider>
      </MsalProvider>
    </StoreContext.Provider>
  </>
);
